/* Neural Scoops (ASD) header: mobile menu and header-height variables.
   Sticky behaviour is pure CSS (see asd-header.css). */

function readHeaderGroup() {
  const group = document.querySelector('#header-group');
  if (!group) return 0;
  let total = 0;
  for (const child of group.children) {
    if (child instanceof HTMLElement) total += child.offsetHeight;
  }
  return total;
}

function publishHeights() {
  const header = document.querySelector('#asd-header');
  if (!header) return;
  const section = header.closest('.shopify-section') || header;
  const h = Math.round(section.offsetHeight);
  // Horizon's own stylesheet declares these on <body>, so they must be set there too
  document.body.style.setProperty('--header-height', `${h}px`);
  document.body.style.setProperty('--header-group-height', `${readHeaderGroup()}px`);
}

/* Scroll-up mode: the desktop page scrolls inside .page-wrapper (base.css, >=990px), not the
   window, so both are read and listened to. All JS does is set data-sticky-state; CSS animates. */
function initScrollUp(header, menu) {
  if (header.dataset.sticky !== 'scroll-up') return;
  const pageWrapper = document.querySelector('.page-wrapper');
  const THRESHOLD = 6;
  let last = 0;
  let ticking = false;

  function readScrollTop() {
    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight) {
      const o = getComputedStyle(pageWrapper).overflowY;
      if (o === 'auto' || o === 'scroll') return pageWrapper.scrollTop;
    }
    return window.scrollY || document.documentElement.scrollTop || 0;
  }
  function setHidden(hidden) {
    if (hidden) header.dataset.stickyState = 'hidden';
    else delete header.dataset.stickyState;
  }
  function update() {
    ticking = false;
    const top = readScrollTop();
    const delta = top - last;
    const busy = (menu && !menu.hidden) || header.contains(document.activeElement);
    if (top <= header.offsetHeight || busy) {
      setHidden(false);
      last = top;
    } else if (Math.abs(delta) >= THRESHOLD) {
      setHidden(delta > 0);
      last = top;
    }
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  pageWrapper?.addEventListener('scroll', onScroll, { passive: true });
}

function init() {
  const header = document.querySelector('#asd-header');
  if (!header || header.dataset.asdReady) return;
  header.dataset.asdReady = 'true';

  const toggle = header.querySelector('.asd-header__toggle');
  const menu = header.querySelector('#asd-mobile-menu');

  if (toggle && menu) {
    const setOpen = (open) => {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
    };
    toggle.addEventListener('click', () => setOpen(menu.hidden));
    menu.addEventListener('click', (e) => {
      if (e.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
    matchMedia('(min-width: 851px)').addEventListener('change', (e) => {
      if (e.matches) setOpen(false);
    });
  }

  initScrollUp(header, menu);

  publishHeights();
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(publishHeights);
    ro.observe(header);
    const group = document.querySelector('#header-group');
    if (group) for (const child of group.children) ro.observe(child);
  } else {
    window.addEventListener('resize', publishHeights);
  }
}

init();
document.addEventListener('shopify:section:load', init);
